import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IframeHTMLAttributes, onMounted } from 'vue'
import KnowledgeBase from './KnowledgeBase.vue'

/*
 * wrapper for KnowledgeBase component that adapts it to HelpKit
 * (generic KnowledgeBase is called via eventBus, which emits article
 * request event to be handled here)
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpKitKnowledgeBase',
  setup(__props) {

window.HelpkitConfig = { hideLaunchButton: true }

const openArticle = (id) => {
  try {
    let popover = document.querySelector('.helpkit-popover')
    if (popover) {
      popover.classList.remove('hidden')
    }
    setTimeout(() => {
      document.getElementById('helpkit-popover-frame')?.focus()
    }, 100)
    if (id) window.Helpkit?.show('popover', 'article', id)
    else window.Helpkit?.show('popover')
  } catch (error) {
    console.log(error)
  }
}

onMounted(() => {
  if (!document.getElementById('helpkit-widget')) {
    const script = document.createElement('script')
    script.setAttribute('id', 'helpkit-widget')
    script.setAttribute('data-project-id', 'livinginfrastructure')
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('src', 'https://www.helpkit.so/widget/script.js')
    script.setAttribute('async', '')
    document.head.appendChild(script)
    script.onerror = () => {
      console.log('failed to load HelpKit')
    }
    script.onload = () => {
      setTimeout(() => {
        window.Helpkit.hideLaunchButton()
        // move the HelpKit popover inside the app container so it won't
        // add extra space at the bottom of the layout
        let popover = document.querySelector('.helpkit-popover')
        if (popover) {
          document.getElementById('app')?.appendChild(popover)
          popover.classList.add('hidden')
        }
      }, 1000)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(KnowledgeBase, { onOpenArticle: openArticle }))
}
}

})